export default class LotStatusDto {
  label: string | null;
  value: number | null;

  constructor() {
    this.label = null;
    this.value = null;
  }
}
